// extracted by mini-css-extract-plugin
module.exports = {"parent":"SuperCentered_parent__fOPx8"};